module.exports = __webpack_public_path__ + "static/media/kayak_selected_ic.ada1d9b1.svg";